import React, {Component} from 'react'
import {findDOMNode} from 'react-dom'
import PropTypes from 'prop-types'
import { Field } from 'redux-form'
import {required} from '../../common/Form/rules'
import Select from 'react-select'


// TODO fix bug on not destroying form when update
class Form extends Component {
    render() {
        const {type, successMessage, confirmText, okButtonTxt, handleSubmit, submitSucceeded, error, submitting, onSubmit, handleClose, qbmEntity, categories = []} = this.props
        const {formatMessage} = this.context

        const {resetForm} = this.props

        const hideFormOnAddMore = type !== "create"

        return (
            <form onSubmit={handleSubmit} className="create-dialog-form crud_form">
                {
                    ["create", "update"].includes(type) &&
                    <Field
                        name = "name"
                        id = "name"
                        type = "text"
                        component = {this.RenderInput}
                        validate = {[required]}
                        label = {type === "create" ? formatMessage("Name") : formatMessage("Edit")}
                        onChange = {(event, newValue) => {
                            if (submitSucceeded && newValue && resetForm) resetForm()
                        }}
                        ref = {this.getFieldRef}
                        autoComplete = "off"
                    />
                }
                {
                    qbmEntity === "category" && type === "create" &&
                    <Field
                        name = "parent"
                        selectProps = {{
                            options : categories,
                            valueKey : "id",
                            labelKey : "name",
                            placeholder : `${formatMessage('Select')}...`,
                        }}
                        component = {this.RenderSelect}
                        label = {formatMessage("Choose relation")}
                    />
                }
                {
                    type === "delete" &&
                    <div className="row mb-5">
                        <div className="col-xs-12 text-center text-danger word-wrap-break">{confirmText}</div>
                    </div>
                }
                {
                    submitSucceeded &&
                    <div className="row mb-3">
                        <div className="col-xs-12 text-center text-success">{successMessage}</div>
                    </div>
                }
                {
                    error &&
                    <div className="row mb-3">
                        <div className="col-xs-12 text-center text-danger">{error}</div>
                    </div>
                }
                <div className="create-dialog-form__group flex">
                    <button
                        disabled={submitting}
                        onClick={handleSubmit((val,...rest)=>onSubmit({...val, hideForm : hideFormOnAddMore, setFocus : hideFormOnAddMore ? null : this.setFocus},...rest))}
                        className="btn btn-primary mr-auto"
                        type="submit"
                    >{okButtonTxt}</button>
                    {
                        type === "create" &&
                        <button
                            disabled={submitting}
                            onClick={handleSubmit((val,...rest)=>onSubmit({...val, hideForm : true},...rest))}
                            className="btn btn-primary"
                            type="submit"
                        >{formatMessage("Add")}</button>
                    }
                    <button
                        onClick={handleClose}
                        className="btn btn-warning"
                        type="button"
                    >{formatMessage("Cancel")}</button>
                </div>
            </form>
        )
    }
    componentDidMount() {
        this.setFocus()
    }
    RenderInput = ({input, meta : {touched, error}, ...customProps}) => {
        const {label, type, id, autoComplete = "on"} = customProps
        return (
            <div className="create-dialog-form__group create-dialog-form__group--indent-bottom">
                <label htmlFor={id}>{label}</label>
                <input
                    {...input}
                    id={id}
                    className="create-dialog-form__control"
                    type={type}
                    autoComplete = {autoComplete}
                />
                {
                    touched && error && <span style={{color:"red"}}>{this.context.formatMessage(error)}</span>
                }
            </div>
        )
    }
    RenderSelect = ({input, ...customProps}) => {
        const {id, label, selectProps = {}} = customProps
        return (
            <div className="create-dialog-form__group create-dialog-form__group--indent-bottom">
                <label htmlFor={id}>{label}</label>
                <Select
                    noResultsText = {this.context.formatMessage('No results found')}
                    {...input}
                    onBlur={() => input.onBlur(input.value)} // !!! REQUIRED !!! https://github.com/erikras/redux-form/issues/82#issuecomment-142393045
                    {...selectProps}
                />
            </div>
        )
    }
    getFieldRef = ref => {
        if (ref) this.input = findDOMNode(ref).querySelector('input')
    }
    setFocus = () => this.input && this.input.focus()

    static contextTypes = {formatMessage: PropTypes.any}
}

export default Form


// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/QbmPage/QbmCrudModal/Form.jsx